function Heading(props) {
    return (
        <font color="white"><h1>{ props.content }</h1></font>
    )
}

export default Heading;